import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import es from "./locales/es.json";
import nl from "./locales/nl.json";

type MessageSchema = typeof fr;

const i18n = createI18n<[MessageSchema], "fr" | "en" | "de" | "it" | "es" | "nl">({
  legacy: false, // you must set `false`, to use Composition API
  locale: "fr", // set default locale
  fallbackLocale: "en", // set fallback locale
  messages: {
    en: en as any,
    fr,
    de: de as any,
    it: it as any,
    es: es as any,
    nl: nl as any,
  },
  // If you need date/time/number formatting:
  datetimeFormats: {
    en: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
    },
    fr: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
    },
    de: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
    },
    it: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
    },
    es: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
    },
    nl: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
    },
  },
  numberFormats: {
    en: {
      currency: {
        style: "currency",
        currency: "EUR",
      },
    },
    fr: {
      currency: {
        style: "currency",
        currency: "EUR",
      },
    },
    de: {
      currency: {
        style: "currency",
        currency: "EUR",
      },
    },
    it: {
      currency: {
        style: "currency",
        currency: "EUR",
      },
    },
    es: {
      currency: {
        style: "currency",
        currency: "EUR",
      },
    },
    nl: {
      currency: {
        style: "currency",
        currency: "EUR",
      },
    },
  },
});

export { i18n };
